import React from 'react';
import "./PostBlockWithCategory.css";
import PostInfo from "../../components/common/PostInfo/PostInfo";
// import { Link } from "react-router-dom";
import 'lazysizes';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { onErrorSrcImg } from '../../helpers';

function PostBlockWithCategory({
  title,
  thumbnail_url,
  url,
  date,
  categoryUrl,
  categoryName,
  hasThirdPartyServiceUrl,
  videoDetailPageLink
}) {
  return (
    <>
      <div className="post-block-with-category">
        {hasThirdPartyServiceUrl ? (
          <a href={videoDetailPageLink} className="post-block-with-category__img-wrapper">
            <img
              className="post-block-with-category__img lazyload"
              data-src={thumbnail_url}
              alt={title}
            />
          </a>
        ) : (
          <a href={`/${url}/`}
            className="post-block-with-category__img-wrapper"
          >
            {/* <img
              className="post-block-with-category__img lazyload"
              data-src={thumbnail_url}
              alt={title}
            /> */}
            <LazyLoadImage
              onError={onErrorSrcImg} // try different version
              alt={title}
              src={thumbnail_url} 
              className="post-block-with-category__img"
            />
          </a>
        )}

        <div className="post-block-with-category__info">
          <p className="post-block-with-category__text">
            {hasThirdPartyServiceUrl ? (
              <a href={`${videoDetailPageLink}`} className="post-block-with-category__link">
                {title}
              </a>
            ) : (
              <a href={`/${url}/`} className="post-block-with-category__link">
                {title}
              </a>
            )}
          </p>
          <PostInfo
            categoryName={categoryName}
            categoryUrl={categoryUrl}
            date={date}
            thirdPartyResource={hasThirdPartyServiceUrl}
            subTitleText=""
          />
        </div>
      </div>
    </>
  );
}

export default PostBlockWithCategory;
